<template>
  <div class="l-clearfix line">
    <div class="fetch" v-bind:class="[{'is-loading': isLoading}]">
      <div class="line-chart">
          <canvas :id="chartid"></canvas>
      </div>
      <div v-if="hasResults" class="line-legend">
        <ul>
          <li v-for="series in legend"><span class="line-legend-series-label">{{ series.label }}</span></li>
        </ul>
      </div>
      
      <div v-else v-bind:class="[{'is-loading': isLoading}]" class="line-message">
          <p>No results that match those filters.</p>
      </div>
    </div>
    <div class="loader-dots line-loader" v-bind:class="[{'is-loading': isLoading}]"><LoaderDots></LoaderDots></div>
  </div>
</template>

<script>
import Chart from 'chart.js'
import LoaderDots from '@/components/LoaderDots'

export default {
  name: 'lineChart',

  components: {
    'LoaderDots': LoaderDots
  },

  props: {
    'chartData': {},
    'chartDataLabelX': '',
    'chartDataLabelY': '',
    'additionalDatasets': '',
    'legend': '',
    'labelPrefix': '',
    'lineColor': '',
    'borderWidth': '',
    'backgroundColor': '',
    'pointBackgroundColor': '',
    'pointBorderColor': ''
  },

  data: function () {
    return {
      chartid: 'line' + this._uid
    }
  },

  computed: {
    hasResults () {
      return (this.chartData.length === -1) ? 0 : 1
    },

    isLoading () {
      return (this.lineChartAmounts.length === 0) ? 1 : 0
    },

    noDataAvailable () {
      if (this.hasResults) {
        return this.chartData.filter(function (series) {
          return series.title === 'No data available'
        })[0]
      }

      return []
    },

    lineChartAmounts () {
      if (this.hasResults) {
        return this.chartDataWithoutNullValues.map(function (data) { return data.amount })
      }

      return []
    },

    lineChartLabels () {
      if (this.hasResults) {
        return this.chartDataWithoutNullValues.map(function (data) { return data.title })
      }

      return []
    },

    chartDataWithoutNullValues () {
      if (this.hasResults) {
        return this.chartData.filter(function (series) {
          return series.title !== 'No data available'
        })
      }

      return []
    },

    prefix () {
      return this.labelPrefix ? this.labelPrefix : ' '
    }
  },

  watch: {
    chartData: function () {
      if (typeof this.theChart === 'object') {
        this.theChart.destroy()
      }

      let vm = this
      let data = {
        labels: vm.lineChartLabels,
        datasets: [{
          borderColor: vm.lineColor,
          borderWidth: vm.borderWidth,
          backgroundColor: vm.backgroundColor,
          pointBorderColor: vm.pointBorderColor,
          pointColor: vm.pointColor,
          data: vm.lineChartAmounts
        }]
      }

      if (vm.additionalDatasets.length > 0) {
        vm.additionalDatasets.forEach(function (dataset) {
          data.datasets.unshift(dataset)
        })
      }

      if (vm.lineChartAmounts.length > 0) {
        vm.theChart = new Chart(document.getElementById(vm.chartid), {
          type: 'line',
          data: data,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              xAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: vm.chartDataLabelX
                },
                ticks: {
                  maxTicksLimit: 16
                }
              }],
              yAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: vm.chartDataLabelY
                },
                ticks: {
                  callback: function (value, index, values) {
                    if (value.toString().length < 8) {
                      return vm.prefix + Number(value).toLocaleString('en-US')
                    }

                    return vm.prefix + Number(Math.round(value / 1000000)).toLocaleString('en-US') + 'mil'
                  }
                }
              }]
            },

            tooltips: {
              // http://www.chartjs.org/docs/#advanced-usage-external-tooltips
              // https://github.com/chartjs/Chart.js/issues/622#issuecomment-249752452
              // Look in chart.js/samples/tooltips
              callbacks: {
                beforeLabel: function (tooltipItem, data) {
                  return ' ' + vm.lineChartLabels[tooltipItem.index]
                },
                label: function (tooltipItem, data) {
                  return vm.prefix + Number(vm.lineChartAmounts[tooltipItem.index]).toLocaleString('en-US')
                }
              }
            },

            legend: {
              display: false
            }
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/line-chart";
</style>



// WEBPACK FOOTER //
// LineChart.vue?1467c0f0